import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import SubjectSelector from '../../SubjectSelector'
import './Selector.scss'

const CLASS = 'insights-portal-editor-selector'

const Selector = props => {
  const subjects = useMemo(() => props.subjects || {}, [props.subjects])

  const select = event => {
    if (props.onItemAdd) props.onItemAdd({ uid: event.uid, left: true })
  }

  return (
    <SubjectSelector
      className={`insights-portal-subject-selector-button ${CLASS}`}
      subjects={subjects}
      split={props.split}
      placeholder={`Add ${props.subjectType}`}
      keepEmpty={true}
      onSelect={select}
    />
  )
}

Selector.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  subjects: PropTypes.object,
  split: PropTypes.string,
  subjectType: PropTypes.string,
  onItemAdd: PropTypes.func
}

export default Selector
